//=============================================================================
//                       <--- Developed By Icon Team ---> 18 January 2021
//=============================================================================

// npm packages
import React, { useEffect, useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// custom pages
import Context from 'context/context';
import Table from 'components/Table/Table';
import useDebounce from 'helpers/useDebounce';
import './css/Location.css';
import { locationStyles } from './styles';
import locationApi from 'apis/location/location';
import Loader from 'components/Loader/Loader';
import access from 'config/access';
import searchIcon from 'assets/img/Search_Icon.png';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import auth from "apis/auth/auth";
import Tooltip from '@material-ui/core/Tooltip';

// material-ui
import { withStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import { Grid, Button, Typography, Paper } from '@material-ui/core'
// material-ui icons
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import * as moment from 'moment';
import authRoutes from 'routes/AuthRoutes/authRoutes';

//Analytics
import { logEvent } from '../../../helpers/analytics';
import {useTrackWithGTM} from 'helpers/gtm';


// custom TextField
const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: '##D3D3D3',
    },
    '& .MuiFormLabel-root': {
      color: '#707070',
    },
    '& .MuiInputBase-input': {
      color: '#707070',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: '#707070!important',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#707070!important',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#707070',
      },
      '&:hover fieldset': {
        borderColor: '#707070',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#707070',
      },
      '&.MuiOutlinedInput-root': {
        borderRadius: 20,
        marginTop: 0,
        background: '#ededed',
        outline: 'none',
      },
      '&.MuiTableCell-root': {
        fontSize: '30px !important',
      },
      '&.MuiTableCell-head': {
        fontSize: '30px !important',
      },
    },
  },
})(TextField);

let GreenTooltip

GreenTooltip = withStyles({
  tooltip: {
    color: "black",
    backgroundColor: "#e8eaeb",
    width: "500px",
    fontSize: "12px",
  },
  arrow: {
    "&:before": {
      backgroundColor: "#e8eaeb",
    },
  },
})(Tooltip);

export default function Locations() {
  const { state, dispatch } = useContext(Context);
  const { getLocations, searchLocation, selectCustomerAccount } = locationApi();
  const history = useHistory();
  const classes = locationStyles();
  const { t, i18n } = useTranslation();

  const [data, setData] = useState([]);
  let location = useLocation();
  const { trackWithGTM } = useTrackWithGTM()
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [hover, setHover] = React.useState({
    name: '',
    active: false,
    billTo: '',
  });

  const searchBounceValues = useDebounce(searchValue);

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: 'SET_PATHNAME',
      payload: ['HOME', 'My Account'],
    });
  }, []);
  
  useEffect(()=>{
    handleredirect()
  },[])

  useEffect(() => {
    handleMarketingAdminFunc();
  }, [state.ALA]);

  const handleMarketingAdminFunc = () => {
    if (
      (state?.userInfo?.role_id === 10 || state?.userInfo?.role_id === 13 || state?.userInfo?.role_id === 3) &&
      state?.ALA?.["Loyalty_Account.dormant_account_flag"] === true && state?.ALA?.["Loyalty_Account.dormant_processed"] === true
    ) {
      history.push('/dashboard/dormant-view');
      return; 
    }
   
    if (access["myDashboard"]["loyalty"][state.userInfo.role]) {
      if (state?.ALA && Object.keys(state?.ALA).length > 0) {
        return;
      }
      return history.push("/dashboard/loyalty");
    }
  };
  
  // handling api calls
  useEffect(() => {
    if (state.ALA && Object.keys(state.ALA).length > 0) {
      searchValue.length > 0 ? getSearch() : getuser();
    }
  }, [state.ALA, offset]);

  const handleredirect = () => {
    if (state?.userInfo?.role_id === null && state?.ALA?.["Loyalty_Account.dormant_account_flag"] === true)
      {
      history.push('/dashboard/dormant-view');
    } 
  };

  useEffect(() => {
    // 🔹 Log page view
    logEvent({
      event_type: "page_view",
      event_name: "Manage My Account",
      user_id: state?.userInfo?.user_id,
      session_id: state?.userInfo?.session_id,
    });
  }, []);

  useEffect(() => {
    if (searchValue?.length > 0) {
      getSearch();
    } else {
      if (offset === 1) {
        getuser();
      } else {
        setOffset(1);
      }
    }
  }, [searchBounceValues]);

  // locations api func
  const getuser = async (values) => {
    try {
      let pagination = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      let loyaltyId = state?.ALA?.loyalty_id;
      dispatch({ type: 'SET_LOADING', payload: true });
      let res = await getLocations(pagination, loyaltyId);
      if (res) {
        setCount(res.count);
        setData(res.data);
        dispatch({ type: 'SET_LOADING', payload: false });
        return res;
      }
    } catch (e) {
      console.log('errors');
    }
  };

  // search api func
  async function getSearch() {
    try {
      let values = {
        searchBounceValues: searchBounceValues,
        offset: (offset - 1) * 10,
        limit: 10,
        loyaltyId: state?.ALA?.loyalty_id,
      };

      // 🔹 Log search action
      logEvent({
        event_type: "click",
        event_name: "Search",
        user_id: state?.userInfo?.user_id,
        session_id: state?.userInfo?.session_id,
        metadata: { query: searchBounceValues }
      });
      trackWithGTM({
        database: state?.userInfo?.loyalty_organization_name,
        event: "click",
        pathname: window.location.pathname,
        userId: state?.userInfo?.user_id,
        role_id:state?.userInfo?.role_id,
        allstate:state
      });

      dispatch({ type: 'SET_LOADING', payload: true });
      let res = await searchLocation(values);
      if (res && res.handleResponse && res.handleResponse.type === 'success') {
        const user = [];
        user.push(res.data);
        setData(res.data);
        setCount(res.count);
        dispatch({ type: 'SET_LOADING', payload: false });
        return res;
      } else {
        setData([]);
        dispatch({ type: 'SET_LOADING', payload: false });
      }
    } catch (error) {
      console.log(error);
    }
  }

  // view details func
  const onClickFunc = (d) => {
    if (d) {
      // 🔹 Log View Details click
      logEvent({
        event_type: "click",
        event_name: "View Details",
        user_id: state?.userInfo?.user_id,
        session_id: state?.userInfo?.session_id,
        metadata: { customer_account_number: d?.customer_account_number }
      });
      trackWithGTM({
        database: state?.userInfo?.loyalty_organization_name,
        event: "click",
        pathname: window.location.pathname,
        userId: state?.userInfo?.user_id,
        role_id:state?.userInfo?.role_id,
        allstate:state
      });

      history.push('/dashboard/view-shipto', { data: d });
    }
  };

  const invalidChar = [
    '~','`','!','#','$','%','^','*','(',')','_','+','=',
    '',';',';',':','<',',','>','/','?','|','[',']','{','}','"',"'",'.',
  ];

  const blockInvalidCharForText = (e) =>
    invalidChar.includes(e.key) && e.preventDefault();

  // selecting Customer Account func
  const handleSelectCustomerAccount = async (obj) => {
    try {
      dispatch({ type: "SET_LOADING", payload: true })
      let values = {
        memberId: obj?.loyalty_id,
        customerId: obj?.customer_account_number
      }
      let res = await selectCustomerAccount(values);
      if (res) {
        dispatch({ type: "SET_ACA", payload: obj });
      }
      dispatch({ type: "SET_LOADING", payload: false })
      return;
    } catch (e) {
      console.log({ e });
    }
  };
  
  const heading1 = [
    'Select View',
    'Ship To Name',
    'Ship To',
    'Bill To',
    'Location',
    'Signature Status',
    'View Detail'
  ]
  
  const heading2 = state?.userInfo?.role_id == 3 || state?.userInfo?.role_id == 10 ? [
    'Select View',
    'Ship To Name',
    'Ship To',
    'Bill To',
    'Address',
    'Status',
    'View Detail',
  ] :
    [
      'Ship To Name',
      'Ship To',
      'Bill To',
      'Address',
      'Status',
      'View Detail',
    ]

  return (
    <React.Fragment>
         <div
          className='container'
          onClick={() => {
            hover.active && setHover({ name: '', active: false });
          }}
        >
          <Grid container spacing={0} style={{ marginBottom: 20 }}>
            <Grid item xs={12} sm={7} lg={7} className={classes.topGrid}>
              <CssTextField
                placeholder={t('Search for Ship To Name or Ship To')}
                type={'text'}
                variant='outlined'
                className={classes.searchInput}
                onKeyDown={blockInvalidCharForText}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      {searchValue.length > 0 ? (
                        <CloseOutlinedIcon
                          className={classes.searchInputIcon}
                          onClick={() => {
                            setSearchValue('');
                            setOffset(1);
                          }}
                        />
                      ) : (
                        <img
                          src={searchIcon}
                          alt=''
                          width='20px'
                          className={classes.searchIcon}
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                }}
                onClick={() => {
                  setOffset(1);
                }}
              />
            </Grid>
          </Grid>
        
          {(state?.ALA?.["Loyalty_Account.dormant_paused_date"])? (
            <div>
              <div className={classes.memberheader}>Membership Details </div>
              <Grid item xs={12} sm={6} lg={6} className={classes.dormantheading}  >
                <GreenTooltip title={t('The date you were enrolled in Thrive Rewards.')} placement="bottom" arrow>
                  <div className={classes.dormantlabel}>Rewards Member Since :
                    <span  style={{ marginLeft: 8,fontSize :15,fontWeight: 'normal' }}>{state?.ALA?.["Loyalty_Account.signup_date"] ?
                      moment(state?.ALA?.["Loyalty_Account.signup_date"]).format('MMM-DD-YYYY') : '-'}</span>
                  </div>
                </GreenTooltip>
                <GreenTooltip title={t('Your rewards points were paused on this date due to inactivity. Any unredeemed points before this date were removed.')} placement="bottom" arrow>
                  <div className={classes.dormantlabel1}>Dormant On :
                    <span style={{ marginLeft: 8,fontSize :15,fontWeight: 'normal' }}>{state?.ALA?.["Loyalty_Account.dormant_paused_date"] ?
                      moment(state?.ALA?.["Loyalty_Account.dormant_paused_date"]).format('MMM-DD-YYYY') : '-'}</span>
                  </div>
                </GreenTooltip>

              </Grid>

              <Grid item xs={12} sm={6} lg={6} className={classes.dormantheading}  >
                <GreenTooltip title={t('Your current tier is guaranteed until this date. After that, we’ll update your tier based on your annual qualifying sales.')} placement="bottom" arrow>
                  <div  className={classes.dormantlabel}>Current Tier Status Valid Until:
                    <span style={{ marginLeft: 8,fontSize :15,fontWeight: 'normal' }}>{state?.ALA?.["Loyalty_Account.tier_end_date"] ?
                      moment(state?.ALA?.["Loyalty_Account.tier_end_date"]).format('MMM-DD-YYYY') : '-'}</span>
                  </div>
                </GreenTooltip>
                <GreenTooltip title={t('The day you resumed earning points after it was paused due to inactivity.')} placement="bottom" arrow>
                  <div  className={classes.dormantlabel2}>Reactivated On :
                    <span style={{ marginLeft: 8,fontSize :15,fontWeight: 'normal' }}>{state?.ACA?.reactivation_date ?
                      moment(state?.ACA?.reactivation_date).format('MMM-DD-YYYY') : "-"}</span>
                  </div>
                </GreenTooltip>

              </Grid>
            </div>
           ) :
            <></>
          } 

          <Loader Loading={state.loading} top={'15%'}>
            <div className={classes.responsiveTable}>
              <Grid item xs={12} sm={12} lg={12}>
                <Table
                  headings={state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' ? heading1 : heading2}
                  data={
                    data &&
                    data.length > 0 &&
                    data.map((p, i) => state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' || (state?.userInfo?.loyalty_organization_name == 'Henry Schein Canada' && (state?.userInfo?.role_id == 3 || state?.userInfo?.role_id == 10)) ? [
                      [
                        <input className={classes.switchtoInput} type="radio" id={i} name={`switchto-${1}`} value={p?.customer_account_number} checked={state?.ACA?.customer_account_number === p?.customer_account_number} onChange={() => { handleSelectCustomerAccount(p) }} />
                      ],
                      p?.['Customer_Account.customer_name'],
                      p?.['customer_account_number'],
                      p?.['customer_billto_account_number'],
                      p?.['Customer_Account.customer_address_city_name'] +
                      ', ' +
                      p?.['Customer_Account.customer_address_state_code'] +
                      ', ' +
                      p?.['Customer_Account.customer_address_country_code'],
                      p?.signature_flag ? "Enrolled" : "Not-Enrolled",
                      [
                        <OpenInNewIcon
                          key={i}
                          style={{ cursor: "pointer" }}
                          onClick={() => onClickFunc(p)}
                        />,
                      ]
                    ] :
                      [
                        p?.['Customer_Account.customer_name'],
                        p?.['customer_account_number'],
                        p?.['customer_billto_account_number'],
                        p?.['Customer_Account.customer_address_city_name'] +
                        ', ' +
                        p?.['Customer_Account.customer_address_state_code'] +
                        ', ' +
                        p?.['Customer_Account.customer_address_country_code'],
                        p?.['is_active'] ? (
                          <div
                            style={{ color: 'green', cursor: 'pointer' }}
                          >
                            {t('Active')}
                          </div>
                        ) : (
                          <div
                            style={{ color: 'red' }}
                          >
                            {'Inactive'}
                          </div>
                        ),
                        [
                          <OpenInNewIcon
                            key={i}
                            style={{ cursor: "pointer" }}
                            onClick={() => onClickFunc(p)}
                          />,
                        ],
                      ]
                    )
                  }
                  offset={offset}
                  count={
                    (count / 10) % 1 == 0
                      ? Math.floor(count / 10)
                      : Math.floor(count / 10 + 1)
                  }
                  handlePagination={handlePagination}
                  style={{ fontSize: '30px!important' }}
                />
              </Grid>
            </div>
          </Loader>
        </div>
    </React.Fragment>
  );
}
